import { useQuery } from "@tanstack/react-query";

import { guestService } from "@/services/guest-service";
import type { GuestFilterResponse } from "@/types/guest";

type UseGuestFilterOptionsArgs = {
  hotelId?: string;
  name?: string;
  enabled?: boolean;
};

export const guestFilterKeys = {
  all: ["guestFilterOptions"] as const,
  list: (hotelId?: string, name?: string) =>
    [...guestFilterKeys.all, hotelId || "", name || ""] as const,
};

export const useGuestFilterOptions = ({
  hotelId,
  name,
  enabled = true,
}: UseGuestFilterOptionsArgs) =>
  useQuery<GuestFilterResponse>({
    queryKey: guestFilterKeys.list(hotelId, name),
    enabled: enabled && !!hotelId,
    queryFn: () =>
      guestService.getGuestFilterOptions({
        hotelId: hotelId!,
        name,
        currentPage: 1,
        perPage: 20,
      }),
    staleTime: 5 * 60 * 1000,
  });
